import auth from '~/auth';

export async function openLabPortal(): Promise<void> {
  const token = await auth.getAccessToken();
  const labPortalUrl = new URL(window.configs.LE_LAB_PORTAL);

  if (labPortalUrl.hostname === 'lab.luxuryescapes.com') {
    labPortalUrl.username = 'customer';
    labPortalUrl.password = 'flash';
  }

  labPortalUrl.searchParams.set('token', token ?? '');
  window.open(labPortalUrl.toString(), '_blank');
}
